export default __webpack_public_path__ + "static/Scalability-Solutions-49fe9e63a70ad6c10a72435aad60e2c7.webp";